// extracted by mini-css-extract-plugin
export default {"addButton":"EmployersScreen_admin_addButton__slwJk"};